export const groupUserIds = (group) => group.relationships.users.data.map((item) => item.id);

export const groupUsers = (group, users) => {
  const userIds = groupUserIds(group);
  return users.filter((user) => userIds.includes(user.id));
};
